import { EmitterEvents, EventActions, LocalSocketStatusActions } from '@/interfaces/event';
import { Client } from './restsend/client';
import { createRsClient } from './restsend/main';
import emitter from './emitter';
import env from '../env';
import { getAuthCookies } from '..';

const validateCallback = (callback: unknown): void => {
  if (typeof callback !== 'function') {
    throw new TypeError('回调必须是一个函数');
  }
};

export interface SocketConfig {
  url: string;
  token: string;
  entId: string;
  agentId: string;
}

class Im {
  static #instance: Im | null = null; // 单例实例

  #client: Client | undefined = undefined;

  private constructor() {
    if (Im.#instance) return Im.#instance;
    Im.#instance = this;
  }

  static getInstance(): Im {
    if (!Im.#instance) {
      Im.#instance = new Im();
    }
    return Im.#instance;
  }

  disconnect() {
    if (this.#client) {
      this.#client.shutdown();
      this.#client = undefined;
    }
    // this.conversations = []
  }
  async connect() {
    this.disconnect();

    const { token } = getAuthCookies();
    const client = createRsClient(env.SOCKET_URL, token);

    this.buildClient(client);
    await client.connect();
  }

  buildClient(client: Client) {
    this.#client = client;
    // this.lastTyping = 0
    // this.quoteMessage = undefined
    client.onConnected = this.onConnected.bind(this);
    client.onNetBroken = this.onNetBroken.bind(this);
    // client.onConversationUpdated = this.onConversationUpdated.bind(this)
    // client.onConversationRemoved = this.onConversationRemoved.bind(this)
    // client.onTopicMessage = this.onTopicMessage.bind(this)
    // client.onTyping = this.onTyping.bind(this)
  }
  onConnected() {
    console.log('onConnected');
    this.emit(LocalSocketStatusActions.CONNECTED);
  }
  onNetBroken(reason: string) {
    console.log('onNetBroken', reason);
    this.emit(LocalSocketStatusActions.DISCONNECTED, reason);
  }

  /** 注册事件监听器 */
  on<T extends EventActions>(eventName: T, callback: (data: EmitterEvents[T]) => void): void {
    validateCallback(callback);
    emitter.on(eventName, callback);
  }

  /** 解绑事件监听器 */
  off<T extends EventActions>(eventName: T, callback: (data: EmitterEvents[T]) => void): void {
    validateCallback(callback);
    emitter.off(eventName, callback);
  }

  /** 发送事件 */
  emit<T extends EventActions>(eventName: T, data?: EmitterEvents[T]): void {
    emitter.emit(eventName, data);
  }
}

const im = Im.getInstance();
export default im;
